var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPardes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 35,
    viewBox: "0 0 27 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4A7054",
    d: "M12.946 33.941c.91 0 1.646-.737 1.646-1.645V13.999c0-.909-.737-1.645-1.646-1.645-.909 0-1.645.736-1.645 1.645v18.297c0 .908.736 1.645 1.645 1.645",
    transform: "translate(.793 .164)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4A7054",
    d: "M12.857 24.6c.546.408 1.33.255 1.762-.273l4.999-6.015c.427-.522.419-1.312-.08-1.765-.534-.485-1.357-.419-1.808.132l-5.094 6.132c-.448.548-.353 1.361.22 1.79",
    transform: "translate(.793 .164)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4A7054",
    d: "M13.438 20.96l-5.095-6.132c-.45-.55-1.272-.617-1.806-.132-.5.455-.509 1.244-.08 1.767l4.998 6.014c.432.527 1.216.682 1.763.274.573-.428.668-1.243.22-1.79",
    transform: "translate(.793 .164)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D1E040",
    d: "M25.387 13.413c0 3.016-2.445 5.461-5.461 5.461-3.016 0-5.46-2.445-5.46-5.461 0-3.016 2.444-5.461 5.46-5.461s5.461 2.445 5.461 5.46",
    transform: "translate(.793 .164)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D1E040",
    d: "M16.723 8.361c0 4.618-3.743 8.361-8.361 8.361S0 12.979 0 8.361 3.744 0 8.362 0s8.36 3.743 8.36 8.361",
    transform: "translate(.793 .164)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#69B045",
    d: "M6.579 5.366c0 .734-.595 1.329-1.33 1.329-.734 0-1.329-.595-1.329-1.33 0-.734.595-1.329 1.33-1.329.734 0 1.329.595 1.329 1.33M10.982 12.79c0 .735-.595 1.33-1.33 1.33-.734 0-1.329-.595-1.329-1.33 0-.734.595-1.329 1.33-1.329.734 0 1.329.595 1.329 1.33M23.572 13.413c0 .736-.597 1.332-1.332 1.332-.736 0-1.332-.596-1.332-1.332 0-.736.596-1.332 1.332-1.332.735 0 1.332.596 1.332 1.332",
    transform: "translate(.793 .164)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPardes);
export default __webpack_public_path__ + "static/media/pardes.e362bad65e3d9053bf3b9d844fe02b03.svg";
export { ForwardRef as ReactComponent };